import "./QuestionYesNo.css";
import CustomCheckBox from "../../Components/custom-checkbox/CustomCheckBox";
import { t } from "i18next";

const QuestionAgreeWidget = ({ questions, setQuestions, isMobile }) => {
  const handleChange = (id, flagValue) => {
    setQuestions((preQuestions) =>
      preQuestions.map((question) =>
        id === question.id ? { ...question, flag: flagValue } : question
      )
    );
  };

  return (
    <div className="survey-container">
      <div className="question-group">
        <div className="question-text" style={{ backgroundColor: "transparent" }} ></div>
        {
          isMobile ? <></>
          :
              <div className="options-question">
                <label className="checkbox-label container-checkbox-label-agree">
                  {t("disagree")}
                </label>
                <label className="checkbox-label container-checkbox-label-disagree">
                  {t("agree")}
                </label>
              </div>
        }
      </div>
      {questions.map((question, index) => (
        <div key={index} className="question-group">
          <div className="question-text">
            <ul>
              {question.text &&
                question.text.map((item, index) => {
                  return <li style={{ listStyleType: "disc" }} key={index}>{item}</li>;
                })}
            </ul>
          </div>
          <div className="options-question">
            {
              isMobile ? 
              <>
              <CustomCheckBox
              value={question.flag === false}
              setValue={() => handleChange(question.id, false)}
              text={t("disagree")}
            />
            <CustomCheckBox
              value={question.flag === true}
              setValue={() => handleChange(question.id, true)}
              text={t("agree")}
            />
              </>
              :
              <>
              <CustomCheckBox
              value={question.flag === false}
              setValue={() => handleChange(question.id, false)}
              text={""}
            />
            <CustomCheckBox
              value={question.flag === true}
              setValue={() => handleChange(question.id, true)}
              text={""}
            />
              </>
            }
            
          </div>
        </div>
      ))}
    </div>
  );
};
export default QuestionAgreeWidget;
